"use strict";

exports.__esModule = true;
exports.TYPE_DOCUMENT = exports.TYPE_ARCHIVE = exports.TYPE_VIDEO = exports.TYPE_IMAGE = void 0;
var TYPE_IMAGE = 'picture';
exports.TYPE_IMAGE = TYPE_IMAGE;
var TYPE_VIDEO = 'video';
exports.TYPE_VIDEO = TYPE_VIDEO;
var TYPE_ARCHIVE = 'archive';
exports.TYPE_ARCHIVE = TYPE_ARCHIVE;
var TYPE_DOCUMENT = 'document';
exports.TYPE_DOCUMENT = TYPE_DOCUMENT;